import {useState, useLayoutEffect} from 'react';
import type {ReactNode} from 'react';
import {Router} from 'react-router-dom';
import {history} from 'browserhistory';

interface CustomRouterProps {
	children: ReactNode;
}

const CustomRouter = ({children}: CustomRouterProps) => {
	const [state, setState] = useState({
		action: history.action,
		location: history.location,
	});

	useLayoutEffect(() => {
		const unlisten = history.listen(setState);
		return unlisten;
	}, []);

	return (
		<Router
			location={state.location}
			navigationType={state.action}
			navigator={history}>
			{children}
		</Router>
	);
};

export default CustomRouter;
